import Homee from "./pages/Homee";

function App() {
  return <Homee />;
}

export default App;
